import { Controller } from '@hotwired/stimulus'

/* This is your ApplicationController. */
export default class extends Controller {
  connect () {}
}
